var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.40045C25 7.29307 24.9 7.18568 24.8333 7.14989L17.1 4C17.0667 4 17.0333 4 16.9667 4C16.9333 4 16.9 4 16.8667 4L9.13333 7.14989C9.06667 7.18568 9 7.29307 9 7.40045V7.97315C9 8.15213 9.1 8.25951 9.26667 8.25951H10.0667V8.68904C10.0667 8.9396 10.2333 9.11857 10.4667 9.11857H23.5333C23.7333 9.11857 23.9333 8.9396 23.9333 8.68904V8.25951H24.7333C24.8667 8.25951 25 8.15213 25 7.97315V7.40045ZM24.2 18.2819H9.8C9.33333 18.2819 9 18.6756 9 19.1409V19.7136C9 19.8926 9.1 20 9.26667 20H24.7333C24.8667 20 25 19.8926 25 19.7136V19.1409C25 18.6756 24.6333 18.2819 24.2 18.2819ZM11.6667 9.69128V16.5638H10.4667C10.2333 16.5638 10.0667 16.7785 10.0667 16.9933V17.7092H23.9333V16.9933C23.9333 16.7785 23.7333 16.5638 23.5333 16.5638H22.3333V9.69128H20.2V16.5638H18.0667V9.69128H15.9333V16.5638H13.8V9.69128H11.6667Z",
    fill: "#294455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericBank);
export default __webpack_public_path__ + "static/media/generic-bank.a989dd954cc9ba11e91610b11a3fbfad.svg";
export { ForwardRef as ReactComponent };